import React          from 'react';
import ReactDom       from 'react-dom';
import Moment         from 'moment';

import Const          from 'fw_const';
import Utils          from 'utils';

import Post           from '@common/post/_post';

import Order          from '@common/influencer-search/order/_order';
// -------------------------------------------------------

class PostList extends React.Component {
  render() {
    let data = this.props.data;
    if( data == undefined ) data = {};
    
    if( data.items == undefined ) data.items = [];
    
    let base = this.props.base;
    
    // プレビューモード
    let preview_mode = '';
    if( this.props.options.order != undefined ) preview_mode = this.props.options.order.column;
    
    return (
      <div className="influencer-list-contents">
        <h3 className="search-result">検索結果 ({Utils.viewInt(data.item_count)})</h3>
        <Order options={this.props.options} mode="post" search_ev={this.props.search_ev.bind(this)} />
        
        <div className="search-influencer-posts">
          { data.items.map((d, key) => {
            let account = { insta_id: d.insta_id, insta_user_id: d.insta_user_id, thumbnail: d.account_thumbnail };
            return <Post key={key} data={d} base={Object.assign(base, this.props.data)} account={account} is_report={false} preview_mode={preview_mode} is_api={true} />
          })}
        </div>
        
        { (data.items.length > 0 && data.items.length < data.item_count ) && <p className="button more" onClick={this.props.more_ev.bind(this)}>続きを見る</p> }
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default PostList;